module.exports = {
      id: "gn-reach-icon-usage",
      viewBox: "0 0 106 36",
      url: __webpack_public_path__ + "svg-sprite-39dbc991ee8a2ec1b35aeef6495011e2.svg#gn-reach-icon",
      toString: function () {
        return this.url;
      }
    }